import React from 'react';
import {CardHeader as KendoCardHeader} from '@progress/kendo-react-layout';

/**
 * CardHeader component wrapping KendoReact CardHeader with all supported props.
 * 
 * @param {object} props
 * @param {React.ReactNode} [props.children] - CardHeader children elements.
 * @param {string} [props.className] - Additional classes for the CardHeader.
 * @param {React.CSSProperties} [props.style] - Additional CSS styles.
 * * @returns {JSX.Element}
 */
export const CardHeader = ({ 
    className = '', 
    style = {}, 
    children
}) => (
  <KendoCardHeader 
    className={className} 
    style={style} 
  >
    {children}
  </KendoCardHeader>
);